import React from 'react';
import Svg from '../../images/ilustrations/Anye_vistas_barco1_new.svg';

const AnyeVistasBarco1 = () => (
    <img src={Svg} alt="Barco" style={{ width: '3em', height: '3em', transform: 'rotate(90deg)', transformOrigin: 'center' }} />
);

export default AnyeVistasBarco1;
